import { computed, type Ref } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { MODULE_ELECTIVE_OFFERINGS } from '@/graphql/Queries/moduleElectiveOfferings';
import type { ModuleElectiveOfferingsQuery } from '@/types/operations';

export function useModuleElectiveOfferings(moduleId: Ref<string>) {
  const { result, loading, error, refetch } = useQuery<ModuleElectiveOfferingsQuery>(MODULE_ELECTIVE_OFFERINGS,
    () => ({ moduleId: moduleId.value }), () => ({ enabled: !!moduleId.value, fetchPolicy: 'network-only' }));
  return { offerings: computed(() => result.value?.moduleElectiveOfferings ?? []), loading, error, refetch };
}
